module.exports = "<div *ngIf=\"showComponent === 'variant'\">\n  <app-variant-details [variant]=\"variant\"></app-variant-details>\n</div>\n\n<div *ngIf=\"showComponent === 'phone'\">\n  <app-phone-list [phone]=\"phone\"></app-phone-list>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/phone-or-variant/phone-or-variant.component.html
// module id = 748
// module chunks = 1